import React, { useEffect } from 'react'
import { PageBuilder } from 'react-pagebuilder/pagebuilder'
import { NextWrapper } from 'data-fetching-wrapper'
import LayoutEmpty from '@components/templates/LayoutEmpty/LayoutEmpty'

const PagebuilderPage = ({ contentTypeId, objectId, pkey, editMode, draft }) => {
  // devo dare la classe react-pagebuilder al body
  useEffect(() => {
    document.body.classList.add('react-pagebuilder-body')
  }, [])

  return (
    <div className="react-pagebuilder">
      <PageBuilder
        contentTypeId={contentTypeId}
        objectId={objectId}
        pkey={pkey}
        editMode={editMode}
        draft={draft}
      />
    </div>
  )
}

export const getServerSideProps = NextWrapper.getServerSideProps(async ({ query }) => {
  return {
    props: {
      contentTypeId: query.contentTypeId,
      objectId: query.objectId,
      pkey: query.key,
      editMode: query.editMode ? query.editMode === 'true' : null,
      draft: query.draft ? query.draft === 'true' : null,
    },
  }
})

PagebuilderPage.Layout = LayoutEmpty

export default PagebuilderPage
